import React from 'react'

export const Forma = () => {
    return (
        <div>Esto quitará el proveedor asignado y los proveedores sugeridos<br />
            Así mismo regersará de estatus la asistencia a buscando proveedor</div>
    )
}
